import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

import colors from '../../styles/colors';

const StyledToastContainer = styled(ToastContainer).attrs({
  className: 'toast-container',
})`
  min-width: 35%;
`;

const Container = styled.div`
  height: calc(100vh - 40px);
  background: ${colors.shades.alpha1};
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
`;

const Header = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin: 0 0 20px 0;
    font-weight: 600;
  }
`;

const Title = styled.h1`
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 600;
`;

const TimeZoneSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
`;

const TimeZoneLabel = styled.div`
  font-size: 0.9rem;
  color: ${colors.shades.gamma7};
  margin-bottom: 8px;
`;

const MainContent = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
`;

const CalendarSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 600px;

  .fc-day-disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.5;
  }
  
  .fc-day-disabled:hover {
    background-color: #f5f5f5;
  }
  
  .fc-day-disabled .fc-daygrid-day-number {
    color: #ccc;
    pointer-events: none;
  }
`;

const DayCell = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const DayNumber = styled.span`
  color: ${({ $isSelected }) => ($isSelected ? colors.base.beta : colors.shades.gamma7)};
  font-weight: ${({ $isSelected }) => ($isSelected ? 600 : 400)};
`;

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 40px 20px;
`;

export {
  Container,
  Header,
  Title,
  TimeZoneSelectorWrapper,
  TimeZoneLabel,
  MainContent,
  CalendarSection,
  DayCell,
  DayNumber,
  ErrorContainer,
  StyledToastContainer,
};
